import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum, AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { saveAs } from "file-saver";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { requestAsync } from "redux-query";
import { getDownloadFileConfig } from "./ins-cashflow-requests-config";
import { exportCustomModel } from "api/admin/src";
import { MessagesDialogFunctionName } from "components/frame/helper";
import { useCustomGetCashFlowCustomModelById } from "hooks/administration/use-cashflow-custom-models";
import { language } from "language/default";
import "./ins-cashflow-model-details.scss";
import { useIsSaveDisabled } from "store/administration/cashflow-forecasting/model-editing/selectors";
import { setExportCffModel, setMessagesDialog } from "store/messages-dialog";
export const doExport = (model, exportedToExcel, dispatch) => {
    if (model?.id) {
        dispatch(setExportCffModel(true));
        dispatch(requestAsync(getDownloadFileConfig({ id: model.id }, "CashflowFile", (params, config) => exportCustomModel(params, { ...config, force: exportedToExcel === undefined }))));
    }
};
export const InsCashflowExportButton = () => {
    const { cashflowCustomModel: model } = useCustomGetCashFlowCustomModelById(), editedModelName = useSelector((state) => state.administration.cashflowForecastingState.modelEditingState.present.cfModelCurrentState?.name);
    const isSaveDisabled = useIsSaveDisabled();
    const dispatch = useDispatch(), exportedToExcel = useSelector((s) => s.entities?.CashflowFile?.[model?.id ?? "content"]), requestedExportCffModel = useSelector((s) => s.messagesDialog?.isCffExportRequested);
    if (requestedExportCffModel && exportedToExcel) {
        saveAs(exportedToExcel, `CffCustomModel_${model?.name}.xlsx`);
        dispatch(setExportCffModel(false));
    }
    return React.createElement(React.Fragment, null,
        React.createElement(AuxButton, { label: language.en.administration.cashflowForecasting.customModels.userModelInspection.configureTab.exportToExcel, size: AuxButtonSizeEnum.SMALL, icon: "download", type: AuxButtonTypeEnum.TERTIARY, isDisabled: ((model?.id ?? "") === "") || (((editedModelName ?? "") !== "") && model.name !== editedModelName), onClick: () => {
                if (isSaveDisabled) {
                    doExport(model, exportedToExcel, dispatch);
                }
                else {
                    dispatch(setMessagesDialog({ functionName: MessagesDialogFunctionName.CashflowExportButton,
                        hasCustomFooter: false,
                        messages: [{ message: language.en.administration.cashflowForecasting.customModels.userModelInspection.exportQuestion }],
                        title: language.en.common.save,
                        type: "alert-with-options" }));
                }
            } }));
};
